module.exports = __webpack_public_path__ + "static/media/6.question_loop.e4006fc8.mp4";